export default function Card() {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 8px 108px rgba(0, 0, 0, 0.06)",
          backgroundColor: "#ffffff",
          borderRadius: "16px"
        }
      },
      variants: [{
        props: {
          raised: false
        },
        style: {
          boxShadow: "none",
        }
      }]
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          "&:last-child": {
            paddingBottom: "16px"
          }
        }
      },
    },
  };
}